import { GlassCard, KYCBadge, BentoGrid, BentoCell } from "@kj/design-system";

export default function ProfilePage() {
  return (
    <div className="flex flex-col gap-6">
      <GlassCard padding="lg" radius="2xl" className="flex flex-wrap items-center gap-4">
        <div
          aria-hidden="true"
          className="h-16 w-16 shrink-0 rounded-full bg-gradient-to-br from-primary-500 via-sakura-500 to-trust-500 shadow-glass-md"
        />
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h2 className="text-lg font-semibold">서준호 / Junho</h2>
            <KYCBadge label="Enhanced KYC" />
          </div>
          <p className="text-sm text-fg-muted">서울 강남구 · IT 엔지니어</p>
        </div>
        <button
          type="button"
          className="rounded-full border border-border px-3 py-1.5 text-xs text-fg-muted hover:text-fg"
        >
          프로필 편집
        </button>
      </GlassCard>

      <BentoGrid>
        <BentoCell span="md" height="sm" title="구독 상태" eyebrow="Plan">
          <p className="text-sm text-fg-muted">
            KJ Pro (₩10,000/월) · 다음 갱신 2026-05-15
          </p>
        </BentoCell>
        <BentoCell span="sm" height="sm" title="토큰" eyebrow="Balance">
          <p className="text-2xl font-semibold">12 <span className="text-sm text-fg-muted">tokens</span></p>
        </BentoCell>
        <BentoCell span="sm" height="sm" title="Hallyu 지수" eyebrow="Taste">
          <p className="text-2xl font-semibold">72 <span className="text-sm text-fg-muted">/100</span></p>
        </BentoCell>
        <BentoCell span="lg" height="sm" title="개인정보·약관" eyebrow="Compliance">
          <p className="text-sm text-fg-muted">
            PIPA · APPI · 인터넷이성소개사업법 고지사항 보기
          </p>
        </BentoCell>
      </BentoGrid>
    </div>
  );
}
